import { createContext, useContext } from 'react';
export var VeltContext = createContext({ client: null });
export function useVeltClient() {
    return useContext(VeltContext);
}
